// ---------- types + subjects ----------
export const DASHBOARD_TYPES = [
    "personal_home",
    "vsm_home",
    "lama_report",
];
export const DASHBOARD_SUBJECT_TYPES = [
    "user",
    "vsm",
    "lama_campaign",
];
/** Subject type is DERIVED from the dashboard type — never client-supplied. */
export const DASHBOARD_TYPE_TO_SUBJECT_TYPE = {
    personal_home: "user",
    vsm_home: "vsm",
    lama_report: "lama_campaign",
};
/**
 * The product module each dashboard type belongs to, or `null` when it belongs
 * to none (PB-4921).
 *
 * A dashboard is the one surface whose owning module cannot be read from the
 * request: `GET /v1/dashboards/{id}` names an id, and the type lives in the
 * stored row. So the gateway cannot gate this path on a module, and the check
 * has to happen where the row is loaded. This map is what makes that possible
 * without a second lookup.
 *
 * Ids are product-module ids — `@playbookai/types` translates to Auth's keys.
 */
export const DASHBOARD_TYPE_TO_PRODUCT_MODULE = {
    personal_home: null,
    vsm_home: "vsm",
    lama_report: "lama",
};
// ---------- server-enforced v1 configuration limits (D23) ----------
export const DASHBOARD_LIMITS = {
    /** personal_home has EXACTLY one page; page add/delete/reorder are rejected. */
    personalHomePages: 1,
    /** vsm_home / lama_report page ceiling. */
    maxPages: 10,
    /** Widget instances per page, every dashboard type. */
    maxWidgetsPerPage: 50,
};
const DATASET_REF_PATTERN = /^([a-z0-9-]+)\/([a-z0-9-]+)@([1-9][0-9]*)$/;
export function parseDatasetContractRef(ref) {
    const match = DATASET_REF_PATTERN.exec(ref);
    if (!match)
        return null;
    return {
        providerKey: match[1],
        datasetKey: match[2],
        contractVersion: Number(match[3]),
    };
}
export function formatDatasetContractRef(parsed) {
    return `${parsed.providerKey}/${parsed.datasetKey}@${parsed.contractVersion}`;
}
// ---------- widget-data resolution wire shapes ----------
export const WIDGET_DATA_ERROR_CODES = [
    "INVALID_CONNECTION",
    "FORBIDDEN",
    "PROVIDER_UNAVAILABLE",
    "PROVIDER_TIMEOUT",
    "RESULT_TOO_LARGE",
    "DASHBOARD_UNSUPPORTED_CONTRACT_VERSION",
];
//# sourceMappingURL=dashboard.js.map